import React, { useState, useEffect } from 'react'
import DashboardLayout from '../components/layout/DashboardLayout' // Sesuaikan path jika berbeda
import { useNavigate } from 'react-router-dom'
import { collection, onSnapshot, doc, deleteDoc, updateDoc } from 'firebase/firestore'
import { getStorage, ref, deleteObject } from 'firebase/storage'
import { db } from '../firebaseConfig' // TODO: SESUAIKAN DENGAN PATH FILE KONFIGURASI FIREBASE ANDA

export default function DriversPage({ user, onLogout }) {
  // State untuk berpindah tab: incomplete, pending, active
  const [activeTab, setActiveTab] = useState('pending')
  const navigate = useNavigate()

  // --- TAMBAHAN KODE: State untuk menyimpan data real dari Firestore ---
  const [driversIncomplete, setDriversIncomplete] = useState([])
  const [driversPending, setDriversPending] = useState([])
  const [driversActive, setDriversActive] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  // State untuk Modal Suspend
  const [isSuspendModalOpen, setIsSuspendModalOpen] = useState(false)
  const [selectedDriver, setSelectedDriver] = useState(null)
  const [suspendReason, setSuspendReason] = useState('')
  const [suspendDuration, setSuspendDuration] = useState(1)
  const [suspendUnit, setSuspendUnit] = useState('hours') // Default 'hours' (Jam) atau 'days' (Hari)

  // Mengambil data real-time dari Firestore menggunakan onSnapshot
  useEffect(() => {
    const q = collection(db, 'drivers')
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const allDrivers = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))

      // Pisahkan data ke masing-masing tab berdasarkan statusnya
      setDriversPending(allDrivers.filter(d => d.status === 'Menunggu Verifikasi'))
      // TAMBAHAN: Masukkan status 'Suspended' ke tab aktif agar admin bisa melihatnya
      setDriversActive(allDrivers.filter(d => d.status === 'Aktif' || d.status === 'Terverifikasi' || d.status === 'Suspended'))
      setDriversIncomplete(allDrivers.filter(d => d.status === 'Belum Lengkap' || d.status === 'Ditolak'))
      
      setIsLoading(false)
    })

    // Bersihkan listener saat halaman ditutup
    return () => unsubscribe()
  }, [])

  // Fungsi bantuan untuk mengubah format waktu Firestore agar enak dibaca
  const formatTime = (timestamp) => {
    if (!timestamp) return '-'
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp)
    return date.toLocaleString('id-ID', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
  }

  // --- TAMBAHAN KODE: Fungsi pembaca layanan aktif dari Admin ---
  const getActiveServices = (driver) => {
    if (driver.service) return driver.service; // Fallback untuk data lama
    if (!driver.adminServices) return 'Belum Diatur';
    const active = Object.keys(driver.adminServices).filter(key => driver.adminServices[key].active === true);
    return active.length > 0 ? active.join(', ') : 'Belum Diatur';
  }

  // --- FUNGSI HAPUS DRIVER (Permanen & Hapus Foto) ---
  const handleDelete = async (driver) => {
    const confirmDelete = window.confirm(
      `PERINGATAN!\n\nYakin ingin menghapus permanen data driver ${driver.name || 'ini'}?\nSemua foto dokumen juga akan terhapus dari server.`
    )
    if (confirmDelete) {
      try {
        const storage = getStorage()
        if (driver.photos) {
          const photoUrls = Object.values(driver.photos)
          for (const url of photoUrls) {
            if (url && url.includes('firebasestorage.googleapis.com')) {
              try {
                const fileRef = ref(storage, url)
                await deleteObject(fileRef)
              } catch (imgError) {
                console.warn("Gambar gagal dihapus:", imgError)
              }
            }
          }
        }
        await deleteDoc(doc(db, 'drivers', driver.id))
        alert('Data driver berhasil dihapus!')
      } catch (error) {
        console.error("Error deleting driver:", error)
        alert('Gagal menghapus data driver.')
      }
    }
  }

  // --- FUNGSI BUKA MODAL SUSPEND ---
  const openSuspendModal = (driver) => {
    setSelectedDriver(driver)
    setSuspendReason('')
    setSuspendDuration(1)
    setSuspendUnit('hours')
    setIsSuspendModalOpen(true)
  }

  // --- FUNGSI EKSEKUSI SUSPEND ---
  const submitSuspend = async () => {
    if (!suspendReason.trim()) {
      alert('Pesan alasan suspend wajib diisi!')
      return
    }
    try {
      const docRef = doc(db, 'drivers', selectedDriver.id)
      const suspendUntilDate = new Date()
      
      if (suspendUnit === 'days') {
        suspendUntilDate.setDate(suspendUntilDate.getDate() + Number(suspendDuration))
      } else {
        suspendUntilDate.setHours(suspendUntilDate.getHours() + Number(suspendDuration))
      }

      await updateDoc(docRef, {
        status: 'Suspended',
        suspendReason: suspendReason,
        suspendUntil: suspendUntilDate,
        isOnline: false,
      })
      
      const unitText = suspendUnit === 'days' ? 'hari' : 'jam'
      alert(`Driver ${selectedDriver.name} berhasil di-suspend selama ${suspendDuration} ${unitText}.`)
      setIsSuspendModalOpen(false)
    } catch (error) {
      console.error("Error suspending:", error)
      alert('Gagal melakukan suspend.')
    }
  }

  // --- FUNGSI BUKA SUSPEND (AKTIFKAN KEMBALI) ---
  const handleUnsuspend = async (driverId) => {
    if (window.confirm('Yakin ingin mengaktifkan kembali (membuka suspend) driver ini?')) {
      try {
        await updateDoc(doc(db, 'drivers', driverId), {
          status: 'Aktif',
          suspendReason: null,
          suspendUntil: null
        })
        alert('Suspend berhasil dibuka. Driver aktif kembali.')
      } catch (error) {
        console.error("Error unsuspending:", error)
        alert('Gagal membuka suspend.')
      }
    }
  }
  // -------------------------------------------------------------------

  return (
    <DashboardLayout user={user} onLogout={onLogout}>
      <div className="text-gray-300">
        <h2 className="text-2xl font-bold mb-6">🚗 Manajemen Drivers (Mitra)</h2>

        {/* --- TABS NAVIGASI --- */}
        <div className="flex gap-4 border-b border-gray-800 mb-6 pb-2">
          <button
            onClick={() => setActiveTab('incomplete')}
            className={`pb-2 px-2 transition ${
              activeTab === 'incomplete'
                ? 'border-b-2 border-red-500 text-red-400 font-semibold'
                : 'text-gray-500 hover:text-gray-300'
            }`}
          >
            Belum Selesai (Draft)
          </button>
          <button
            onClick={() => setActiveTab('pending')}
            className={`pb-2 px-2 transition ${
              activeTab === 'pending'
                ? 'border-b-2 border-orange-500 text-orange-400 font-semibold'
                : 'text-gray-500 hover:text-gray-300'
            }`}
          >
            Menunggu Verifikasi
          </button>
          <button
            onClick={() => setActiveTab('active')}
            className={`pb-2 px-2 transition ${
              activeTab === 'active'
                ? 'border-b-2 border-blue-500 text-blue-400 font-semibold'
                : 'text-gray-500 hover:text-gray-300'
            }`}
          >
            Driver Aktif
          </button>
        </div>

        {/* --- KONTEN TAB: BELUM SELESAI (INCOMPLETE) --- */}
        {activeTab === 'incomplete' && (
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 shadow-lg">
            <h3 className="text-lg font-semibold mb-4 text-white">Driver Belum Selesai Daftar</h3>
            <p className="text-gray-400 mb-6 text-sm">
              Calon mitra yang sudah membuat akun atau mengisi form sebagian, namun belum menyelesaikan tahap Training atau belum melengkapi Dokumen.
            </p>

            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="border-b border-gray-700 text-sm text-gray-400">
                    <th className="py-3 px-4 font-medium">Nama Driver</th>
                    <th className="py-3 px-4 font-medium">No. HP</th>
                    <th className="py-3 px-4 font-medium">Status Terakhir</th>
                    <th className="py-3 px-4 font-medium text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody className="text-sm">
                  {isLoading ? (
                    <tr><td colSpan="4" className="py-4 text-center text-gray-500">Memuat data...</td></tr>
                  ) : driversIncomplete.length === 0 ? (
                    <tr><td colSpan="4" className="py-4 text-center text-gray-500">Tidak ada data.</td></tr>
                  ) : (
                    driversIncomplete.map(driver => (
                      <tr key={driver.id} className="border-b border-gray-800 hover:bg-gray-800/50 transition">
                        <td className="py-3 px-4 text-white font-medium">{driver.name || '-'}</td>
                        <td className="py-3 px-4">{driver.phone || '-'}</td>
                        <td className="py-3 px-4 text-red-400">{driver.status}</td>
                        <td className="py-3 px-4 text-center">
                          <button 
                            onClick={() => handleDelete(driver)}
                            className="text-red-400 hover:bg-red-900/40 hover:text-red-300 transition text-xs border border-red-500/30 px-3 py-1.5 rounded"
                          >
                            🗑️ Hapus
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* --- KONTEN TAB: MENUNGGU VERIFIKASI --- */}
        {activeTab === 'pending' && (
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 shadow-lg">
            <h3 className="text-lg font-semibold mb-4 text-white">Siap Ditinjau</h3>
            <p className="text-gray-400 mb-6 text-sm">
              Calon mitra ini sudah <b>selesai upload dokumen dan lulus training</b>. Silakan periksa keaslian dokumen mereka.
            </p>

            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="border-b border-gray-700 text-sm text-gray-400">
                    <th className="py-3 px-4 font-medium">Nama Driver</th>
                    <th className="py-3 px-4 font-medium">Kode Referral</th> {/* <-- BARU */}
                    <th className="py-3 px-4 font-medium">Layanan</th>
                    <th className="py-3 px-4 font-medium">Plat Nomor</th>
                    <th className="py-3 px-4 font-medium">Waktu Selesai</th>
                    <th className="py-3 px-4 font-medium text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody className="text-sm">
                  {isLoading ? (
                    <tr><td colSpan="6" className="py-4 text-center text-gray-500">Memuat data...</td></tr>
                  ) : driversPending.length === 0 ? (
                    <tr><td colSpan="6" className="py-4 text-center text-gray-500">Tidak ada driver yang menunggu verifikasi.</td></tr>
                  ) : (
                    driversPending.map(driver => (
                      <tr key={driver.id} className="border-b border-gray-800 hover:bg-gray-800/50 transition">
                        <td className="py-3 px-4 text-white font-medium">{driver.name || '-'}</td>
                        <td className="py-3 px-4 text-orange-400 font-bold">{driver.usedReferralCode || '-'}</td> {/* <-- BARU */}
                        <td className="py-3 px-4 text-blue-400 font-bold">{getActiveServices(driver)}</td>
                        <td className="py-3 px-4">{driver.vehiclePlate || '-'}</td>
                        <td className="py-3 px-4 text-gray-400">{formatTime(driver.createdAt)}</td>
                        <td className="py-3 px-4 text-center">
                          <button 
                            onClick={() => navigate(`/drivers/approve/${driver.id}`)} 
                            className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded text-xs font-medium mr-2 transition"
                          >
                            Detail
                          </button>
                          <button 
                            onClick={() => handleDelete(driver)}
                            className="text-red-400 hover:bg-red-900/40 hover:text-red-300 transition text-xs border border-red-500/30 px-3 py-1.5 rounded"
                          >
                            🗑️ Hapus
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* --- KONTEN TAB: DRIVER AKTIF --- */}
        {activeTab === 'active' && (
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 shadow-lg">
            <h3 className="text-lg font-semibold mb-2 text-white">Driver Terdaftar</h3>
            <p className="text-gray-400 text-sm mb-6">
              Daftar seluruh driver Zimo yang saat ini sudah beroperasi.
            </p>
            
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="border-b border-gray-700 text-sm text-gray-400">
                    <th className="py-3 px-4 font-medium">Nama Driver</th>
                    <th className="py-3 px-4 font-medium">Layanan</th>
                    <th className="py-3 px-4 font-medium">Rating</th>
                    <th className="py-3 px-4 font-medium">Status Operasi</th>
                    <th className="py-3 px-4 font-medium text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody className="text-sm">
                  {isLoading ? (
                    <tr><td colSpan="5" className="py-4 text-center text-gray-500">Memuat data...</td></tr>
                  ) : driversActive.length === 0 ? (
                    <tr><td colSpan="5" className="py-4 text-center text-gray-500">Belum ada driver aktif.</td></tr>
                  ) : (
                    driversActive.map(driver => (
                      <tr key={driver.id} className="border-b border-gray-800 hover:bg-gray-800/50 transition">
                        <td className="py-3 px-4 text-white font-medium">{driver.name || '-'}</td>
                        <td className="py-3 px-4 text-green-400">{getActiveServices(driver)}</td>
                        {/* 👈 PERBAIKAN: Format Rating 2 desimal di daftar driver */}
                        <td className="py-3 px-4 text-yellow-400 font-semibold">
                          ⭐ {driver.avgRating ? Number(driver.avgRating).toFixed(2) : 'Baru'}
                        </td>
                        <td className="py-3 px-4">
                          {driver.status === 'Suspended' ? (
                            <span className="text-red-400 font-semibold bg-red-900/30 px-2 py-1 rounded">Suspended</span>
                          ) : (
                            <span className={driver.isOnline ? "text-green-500" : "text-gray-400"}>
                              {driver.isOnline ? 'Online' : 'Offline'}
                            </span>
                          )}
                        </td>
                        <td className="py-3 px-4 text-center flex justify-center gap-2">
                          {/* --- TAMBAHAN KODE: Tombol Detail --- */}
                          <button 
                            onClick={() => navigate(`/drivers/approve/${driver.id}`)} 
                            className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded text-xs font-medium transition"
                          >
                            Detail
                          </button>

                          {driver.status === 'Suspended' ? (
                            <button 
                              onClick={() => handleUnsuspend(driver.id)}
                              className="bg-green-600 hover:bg-green-500 text-white px-3 py-1.5 rounded text-xs transition"
                            >
                              Buka Suspend
                            </button>
                          ) : (
                            <button 
                              onClick={() => openSuspendModal(driver)}
                              className="border border-orange-500 text-orange-400 hover:bg-orange-500 hover:text-white px-3 py-1.5 rounded text-xs transition"
                            >
                              Suspend
                            </button>
                          )}
                          <button 
                            onClick={() => handleDelete(driver)}
                            className="border border-red-500 text-red-400 hover:bg-red-500 hover:text-white px-3 py-1.5 rounded text-xs transition"
                          >
                            Hapus
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

      </div>

      {/* --- MODAL SUSPEND DRIVER --- */}
      {isSuspendModalOpen && selectedDriver && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
          <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 w-full max-w-md shadow-2xl">
            <h3 className="text-xl font-bold text-white mb-2">Suspend Driver</h3>
            <p className="text-sm text-gray-400 mb-6">
              Tangguhkan akun <span className="text-white font-semibold">{selectedDriver.name}</span> sementara. Driver tidak akan bisa menerima orderan selama masa suspend.
            </p>

            <div className="space-y-4">
              <div>
                <label className="block text-sm text-gray-400 mb-1">Pesan Alasan Suspend (Terlihat oleh driver)</label>
                <textarea 
                  value={suspendReason}
                  onChange={(e) => setSuspendReason(e.target.value)}
                  className="w-full bg-gray-800 border border-gray-700 rounded-lg p-3 text-white text-sm focus:border-orange-500 focus:outline-none"
                  rows="3"
                  placeholder="Misal: Terdapat laporan pelanggan mengenai cara berkendara yang berbahaya..."
                ></textarea>
              </div>
              
              <div>
                <label className="block text-sm text-gray-400 mb-1">Durasi Suspend</label>
                <div className="flex gap-2">
                  <input 
                    type="number" 
                    min="1"
                    value={suspendDuration}
                    onChange={(e) => setSuspendDuration(e.target.value)}
                    className="w-2/3 bg-gray-800 border border-gray-700 rounded-lg p-3 text-white text-sm focus:border-orange-500 focus:outline-none"
                  />
                  <select
                    value={suspendUnit}
                    onChange={(e) => setSuspendUnit(e.target.value)}
                    className="w-1/3 bg-gray-800 border border-gray-700 rounded-lg p-3 text-white text-sm focus:border-orange-500 focus:outline-none"
                  >
                    <option value="hours">Jam</option>
                    <option value="days">Hari</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="flex gap-3 mt-8">
              <button 
                onClick={() => setIsSuspendModalOpen(false)}
                className="flex-1 bg-transparent border border-gray-600 text-gray-300 py-2.5 rounded-lg text-sm font-semibold hover:bg-gray-800 transition"
              >
                Batal
              </button>
              <button 
                onClick={submitSuspend}
                className="flex-1 bg-orange-600 text-white py-2.5 rounded-lg text-sm font-semibold hover:bg-orange-700 transition"
              >
                Terapkan Suspend
              </button>
            </div>
          </div>
        </div>
      )}
      
    </DashboardLayout>
  )
}